import {
    type EventApplicationWithoutAuthResponseType,
    type EventApplicationWithoutAuthRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const EventApplicationWithoutAuth = async (params: EventApplicationWithoutAuthRequestType): Promise<EventApplicationWithoutAuthResponseType> => {
    return await axios(`${SERVER_ADDRESS}/event/eventApplicationWithoutAuth`, {
        method: "POST",
        headers: getHeaders(),
        data: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default EventApplicationWithoutAuth;
